import React from 'react';
import {FormNameEnum} from 'filters-selections/enums';
import {RangeSelect} from './RangeSelect';

export const RangeFromSelect = () => {
  return <RangeSelect name={FormNameEnum.rangeFrom} label="From" disabled={false} />;
};
